import { render, staticRenderFns } from "./zheng.vue?vue&type=template&id=23147ea9&scoped=true&"
import script from "./zheng.vue?vue&type=script&lang=js&"
export * from "./zheng.vue?vue&type=script&lang=js&"
import style0 from "./zheng.vue?vue&type=style&index=0&id=23147ea9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23147ea9",
  null
  
)

export default component.exports